// FahrerForm shows a form for the user to add input
// import _ from 'lodash';
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import * as actions from '../../actions'
import ReactFileReader from 'react-file-reader'

const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

class FahrerCSVUpload extends Component {

	constructor (props) {
		super(props);
		this.state = {};

	}

	listEmails = async function (l) {
		for (const m in l) {
			const myMailAdr = await m.strip();
			console.log(myMailAdr);
		}
	}

	handleFiles = files => {
		//console.log(files);

		const that = this;

		const reader = new FileReader();
		reader.onload = function (e) {
			//console.log(reader.result);
			const s = reader.result;
			const a = s.split(/\r\n|\n/).filter(m => m !== '').map(m => m.trim());
			const a_final = [];

			for (var i=0; i<a.length; i++) {

			//for (const m of a) {
				const m = a[i]
				console.log(m, m.length);
				if (re.test(m) === true) {
					a_final.push(m)
				}
				// So, und jetz hier einen Filter einbauen, Emails validieren
				// und dann die Liste ans Backend schicken. ;-)
			}
			console.log("a_final:", a_final);
			that.props.actions.submitFahrerBatch(a);
		}

		reader.readAsText(files[0]);
	}

	render () {
		return (
			<div>
				<h4 style={{fontStyle:'italic'}}>Teilnehmerliste hochladen</h4>
				<p>Hier kann man eine Teilnehmerliste hochladen, Format: CSV-Datei mit einer Spalte mit den Email-Adressen der Teilnehmer.</p>
				<button className="btn btn-secondary">
					<Link className="btn btn-secondary" to={'/fahrer'}>
						Abbrechen
					</Link>
				</button>
				
				<ReactFileReader handleFiles={this.handleFiles} fileTypes={'.csv'}>
					<button className="btn">Upload</button>
				</ReactFileReader>
			</div>
		)
	}
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

function mapStateToProps(state) {
	return {

	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FahrerCSVUpload)



// WEBPACK FOOTER //
// ./src/components/fahrer/FahrerCSVUpload.js